(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[211],{

/***/ "RgPE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("1t7P");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("LW0h");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("jwue");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("daRM");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("FtHn");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("+KXO");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("7x/C");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.promise.js
var es_promise = __webpack_require__("JtPf");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.link.js
var es_string_link = __webpack_require__("hBvt");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("+oxZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("zjfJ");

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__("HbGN");

// EXTERNAL MODULE: /opt/webapp/node_modules/next/dynamic.js
var dynamic = __webpack_require__("hNT8");
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ../utils/dist/index.js
var dist = __webpack_require__("n4CU");

// EXTERNAL MODULE: ./src/client/components/widgets/hero/Hero.jsx
var Hero = __webpack_require__("2B1m");

// EXTERNAL MODULE: ./src/client/components/frameworks/site-container/SiteContainer.jsx
var SiteContainer = __webpack_require__("ZNfd");

// EXTERNAL MODULE: ./src/client/context/ReactAppContext.js
var ReactAppContext = __webpack_require__("Ub5k");

// EXTERNAL MODULE: /opt/webapp/node_modules/next/router.js
var next_router = __webpack_require__("Bkb1");

// EXTERNAL MODULE: ./src/utils/uri/uriUtils.js
var uriUtils = __webpack_require__("nv//");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__("jQ3i");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("KOtZ");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("ho0z");

// EXTERNAL MODULE: /opt/webapp/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__("x4t0");

// EXTERNAL MODULE: ./src/client/cms/toolkit/constants.js
var constants = __webpack_require__("psNz");

// CONCATENATED MODULE: ./src/client/components/lines/immersive-line/ImmersiveLine.utils.js








var ImmersiveLine_utils_getMinPrice = function getMinPrice(_ref, minPrice) {
  var name = _ref.name,
      _ref$props = _ref.props,
      _ref$props$lines = _ref$props.lines,
      lines = _ref$props$lines === void 0 ? [] : _ref$props$lines,
      props = Object(objectWithoutProperties["a" /* default */])(_ref$props, ["lines"]);

  if ([constants["I" /* PRODUCTS_FILTERS */], constants["hb" /* RESORT_GRID */], constants["nb" /* RESORT_RECOMMENDATIONS */]].includes(name)) {
    var _props$recommendation, _props$offer;

    var products = props.products || ((_props$recommendation = props.recommendations) === null || _props$recommendation === void 0 ? void 0 : _props$recommendation.products) || ((_props$offer = props.offer) === null || _props$offer === void 0 ? void 0 : _props$offer.products) || [];
    minPrice = products.reduce(function (min, product) {
      var _product$price, _product$price$bestPr, _min$bestPrice, _min$bestPrice2;

      return ((_product$price = product.price) === null || _product$price === void 0 ? void 0 : (_product$price$bestPr = _product$price.bestPrice) === null || _product$price$bestPr === void 0 ? void 0 : _product$price$bestPr.value) && product.price.bestPrice.value < (min === null || min === void 0 ? void 0 : (_min$bestPrice = min.bestPrice) === null || _min$bestPrice === void 0 ? void 0 : _min$bestPrice.value) || !(min === null || min === void 0 ? void 0 : (_min$bestPrice2 = min.bestPrice) === null || _min$bestPrice2 === void 0 ? void 0 : _min$bestPrice2.value) ? product.price : min;
    }, minPrice);
  }

  if (lines.length > 0) {
    lines.forEach(function (line) {
      minPrice = getMinPrice(line, minPrice);
    });
  }

  return minPrice;
};
// CONCATENATED MODULE: ./src/client/components/lines/immersive-line/ImmersiveLine.jsx













var __jsx = react_default.a.createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(defineProperty["a" /* default */])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }










var FacetSearch = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(0), __webpack_require__.e(14), __webpack_require__.e(16), __webpack_require__.e(19), __webpack_require__.e(132)]).then(__webpack_require__.bind(null, "ontP")).then(function (x) {
    return x.FacetSearch;
  });
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/("ontP")];
    },
    modules: ["../../widgets/facet-search/FacetSearch"]
  }
});

var ImmersiveLine_formatLabelWithPrice = function formatLabelWithPrice(_ref) {
  var label = _ref.label,
      price = _ref.price;
  return Object(dist["messageFormat"])(label || '').format({
    best_price_on_page: price
  });
};

var ImmersiveLine_ImmersiveLine = function ImmersiveLine(_ref2) {
  var _minPrice$bestPrice, _dynamicPrice$link, _dynamicPrice$link2, _props$link, _props$link2;

  var config = _ref2.config,
      _ref2$dynamicPrice = _ref2.dynamicPrice,
      dynamicPrice = _ref2$dynamicPrice === void 0 ? {} : _ref2$dynamicPrice,
      _ref2$displaySearch = _ref2.displaySearch,
      displaySearch = _ref2$displaySearch === void 0 ? false : _ref2$displaySearch,
      id = _ref2.id,
      _ref2$pageLines = _ref2.pageLines,
      pageLines = _ref2$pageLines === void 0 ? [] : _ref2$pageLines,
      props = Object(objectWithoutProperties["a" /* default */])(_ref2, ["config", "dynamicPrice", "displaySearch", "id", "pageLines"]);

  var appContext = Object(ReactAppContext["c" /* useAppContext */])();
  var router = Object(next_router["useRouter"])();
  var displayDynamicPrice = dynamicPrice.displayDynamicPrice;
  var minPrice = displayDynamicPrice ? ImmersiveLine_utils_getMinPrice({
    props: {
      lines: pageLines
    }
  }) : undefined;
  var formattedMinPrice = (minPrice === null || minPrice === void 0 ? void 0 : (_minPrice$bestPrice = minPrice.bestPrice) === null || _minPrice$bestPrice === void 0 ? void 0 : _minPrice$bestPrice.formattedValue) || '';
  var dynamicPriceLabels = displayDynamicPrice && !!formattedMinPrice ? {
    title: ImmersiveLine_formatLabelWithPrice({
      label: dynamicPrice.title,
      price: formattedMinPrice
    }),
    subtitle: ImmersiveLine_formatLabelWithPrice({
      label: dynamicPrice.subtitle,
      price: formattedMinPrice
    }),
    link: {
      url: ((_dynamicPrice$link = dynamicPrice.link) === null || _dynamicPrice$link === void 0 ? void 0 : _dynamicPrice$link.url) || '',
      label: ImmersiveLine_formatLabelWithPrice({
        label: (_dynamicPrice$link2 = dynamicPrice.link) === null || _dynamicPrice$link2 === void 0 ? void 0 : _dynamicPrice$link2.label,
        price: formattedMinPrice
      })
    }
  } : {};

  var newLink = _objectSpread(_objectSpread({}, props.link), {}, {
    url: ((_props$link = props.link) === null || _props$link === void 0 ? void 0 : _props$link.url) ? Object(uriUtils["e" /* formatLink */])((_props$link2 = props.link) === null || _props$link2 === void 0 ? void 0 : _props$link2.url, appContext.originalUrl, router.query.locale) : ''
  });

  return __jsx(react["Fragment"], null, __jsx("div", {
    className: "Line Line-Immersive",
    id: id
  }, __jsx(Hero["a" /* Hero */], Object(esm_extends["a" /* default */])({}, props, {
    link: newLink,
    hasOverlap: displaySearch,
    isImmersive: true
  }, dynamicPriceLabels, {
    as: "a"
  }))), displaySearch && __jsx(SiteContainer["a" /* SiteContainer */], {
    className: "Line Line-Search isolate relative z-1"
  }, __jsx(FacetSearch, {
    i18n: config,
    searchPageRouteName: "search",
    shouldRedirectToResortPage: true,
    withSearchForm: true
  })));
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/immersive/descriptor.js

/* harmony default export */ var descriptor = __webpack_exports__["default"] = (ImmersiveLine_ImmersiveLine);

/***/ })

}]);